export function minuteValidator(string: string, position: number): boolean {
  return true;
}
